module.exports = __webpack_public_path__ + "img/logo_sticky.8636b975.png";